(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["to-announcement-bar-inline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindAnnouncement = (root) => {
      root.querySelectorAll('[data-to-announcement-section]').forEach((section) => {
        if (section.dataset.bound === 'true') return;
        section.dataset.bound = 'true';

        const items = Array.from(section.querySelectorAll('[data-to-announcement-item]'));
        if (items.length <= 1) return;

        let index = 0;
        let timer;

        const render = () => {
          items.forEach((item, itemIndex) => {
            item.hidden = itemIndex !== index;
          });
        };

        const restart = () => {
          if (timer) window.clearInterval(timer);
          timer = window.setInterval(() => {
            index = (index + 1) % items.length;
            render();
          }, 4000);
        };

        const prevButton = section.querySelector('[data-to-announcement-prev]');
        const nextButton = section.querySelector('[data-to-announcement-next]');

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            index = (index - 1 + items.length) % items.length;
            render();
            restart();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            index = (index + 1) % items.length;
            render();
            restart();
          });
        }

        render();
        restart();
      });
    };

    document.addEventListener('DOMContentLoaded', () => bindAnnouncement(document));
    document.addEventListener('shopify:section:load', (event) => bindAnnouncement(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["to-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindAnnouncement = (root) => {
      root.querySelectorAll('[data-to-announcement-section]').forEach((section) => {
        if (section.dataset.bound === 'true') return;
        section.dataset.bound = 'true';

        const items = Array.from(section.querySelectorAll('[data-to-announcement-item]'));
        if (items.length <= 1) return;

        let index = 0;
        let timer;

        const render = () => {
          items.forEach((item, itemIndex) => {
            item.hidden = itemIndex !== index;
          });
        };

        const restart = () => {
          if (timer) window.clearInterval(timer);
          timer = window.setInterval(() => {
            index = (index + 1) % items.length;
            render();
          }, 4000);
        };

        const prevButton = section.querySelector('[data-to-announcement-prev]');
        const nextButton = section.querySelector('[data-to-announcement-next]');

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            index = (index - 1 + items.length) % items.length;
            render();
            restart();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            index = (index + 1) % items.length;
            render();
            restart();
          });
        }

        render();
        restart();
      });
    };

    document.addEventListener('DOMContentLoaded', () => bindAnnouncement(document));
    document.addEventListener('shopify:section:load', (event) => bindAnnouncement(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["to-site-header-inline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCards = (root) => {
      root.querySelectorAll('[data-to-product-card]').forEach((card) => {
        const selected = card.querySelector('[data-to-variant].is-selected') || card.querySelector('[data-to-variant]');
        if (selected) {
          const price = card.querySelector('[data-to-product-price]');
          const image = card.querySelector('[data-to-product-image]');
          if (price && selected.dataset.price) price.textContent = selected.dataset.price;
          if (image && selected.dataset.image) image.src = selected.dataset.image;
        }
      });
    };

    const updateShelf = (shelf, nextPage) => {
      const cards = Array.from(shelf.querySelectorAll('[data-to-product-card]'));
      const pageSize = Number(shelf.dataset.pageSize || 4);
      const totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      const safePage = Math.max(0, Math.min(nextPage, totalPages - 1));
      const status = shelf.querySelector('[data-to-home-page-status]');
      const progress = shelf.querySelector('[data-to-home-progress]');
      const prev = shelf.querySelector('[data-to-home-page-button="prev"]');
      const next = shelf.querySelector('[data-to-home-page-button="next"]');

      cards.forEach((card, index) => {
        const visible = index >= safePage * pageSize && index < (safePage + 1) * pageSize;
        card.hidden = !visible;
      });

      if (status) {
        status.textContent = String(safePage + 1).padStart(2, '0') + ' / ' + String(totalPages).padStart(2, '0');
      }

      if (progress) {
        progress.style.setProperty('--to-progress', ((safePage + 1) / totalPages * 100).toFixed(2) + '%');
      }

      if (prev) prev.disabled = safePage === 0;
      if (next) next.disabled = safePage >= totalPages - 1;
      shelf.dataset.currentPage = String(safePage);
    };

    const initShelves = (root) => {
      root.querySelectorAll('[data-to-home-shelf]').forEach((shelf) => {
        updateShelf(shelf, Number(shelf.dataset.currentPage || 0));
      });
    };

    const initDrawer = () => {
      document.querySelectorAll('[data-to-mobile-toggle]').forEach((toggle) => {
        if (toggle.dataset.bound === 'true') return;
        toggle.dataset.bound = 'true';
        toggle.addEventListener('click', () => {
          const drawer = document.querySelector('[data-to-mobile-drawer]');
          if (!drawer) return;
          drawer.hidden = !drawer.hidden;
          document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
            button.setAttribute('aria-expanded', drawer.hidden ? 'false' : 'true');
          });
        });
      });
    };

    const init = (root = document) => {
      initCards(root);
      initShelves(root);
      initDrawer();
    };

    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('[data-to-mobile-drawer]');
      if (drawer && !drawer.hidden) {
        const clickedToggle = event.target.closest('[data-to-mobile-toggle]');
        const clickedDrawer = event.target.closest('[data-to-mobile-drawer]');
        if (!clickedToggle && !clickedDrawer) {
          drawer.hidden = true;
          document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
            button.setAttribute('aria-expanded', 'false');
          });
        }
      }

      const variantButton = event.target.closest('[data-to-variant]');
      if (variantButton) {
        const card = variantButton.closest('[data-to-product-card]');
        if (!card) return;
        card.querySelectorAll('[data-to-variant]').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        variantButton.classList.add('is-selected');
        variantButton.setAttribute('aria-pressed', 'true');

        const price = card.querySelector('[data-to-product-price]');
        const image = card.querySelector('[data-to-product-image]');
        if (price && variantButton.dataset.price) price.textContent = variantButton.dataset.price;
        if (image && variantButton.dataset.image) image.src = variantButton.dataset.image;
        return;
      }

      const pageButton = event.target.closest('[data-to-home-page-button]');
      if (pageButton) {
        const shelf = pageButton.closest('[data-to-home-shelf]');
        if (!shelf) return;
        const current = Number(shelf.dataset.currentPage || 0);
        const nextPage = pageButton.dataset.toHomePageButton === 'next' ? current + 1 : current - 1;
        updateShelf(shelf, nextPage);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const drawer = document.querySelector('[data-to-mobile-drawer]');
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('DOMContentLoaded', () => init(document));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["to-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCards = (root) => {
      root.querySelectorAll('[data-to-product-card]').forEach((card) => {
        const selected = card.querySelector('[data-to-variant].is-selected') || card.querySelector('[data-to-variant]');
        if (selected) {
          const price = card.querySelector('[data-to-product-price]');
          const image = card.querySelector('[data-to-product-image]');
          if (price && selected.dataset.price) price.textContent = selected.dataset.price;
          if (image && selected.dataset.image) image.src = selected.dataset.image;
        }
      });
    };

    const updateShelf = (shelf, nextPage) => {
      const cards = Array.from(shelf.querySelectorAll('[data-to-product-card]'));
      const pageSize = Number(shelf.dataset.pageSize || 4);
      const totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      const safePage = Math.max(0, Math.min(nextPage, totalPages - 1));
      const status = shelf.querySelector('[data-to-home-page-status]');
      const progress = shelf.querySelector('[data-to-home-progress]');
      const prev = shelf.querySelector('[data-to-home-page-button="prev"]');
      const next = shelf.querySelector('[data-to-home-page-button="next"]');

      cards.forEach((card, index) => {
        const visible = index >= safePage * pageSize && index < (safePage + 1) * pageSize;
        card.hidden = !visible;
      });

      if (status) {
        status.textContent = String(safePage + 1).padStart(2, '0') + ' / ' + String(totalPages).padStart(2, '0');
      }

      if (progress) {
        progress.style.setProperty('--to-progress', ((safePage + 1) / totalPages * 100).toFixed(2) + '%');
      }

      if (prev) prev.disabled = safePage === 0;
      if (next) next.disabled = safePage >= totalPages - 1;
      shelf.dataset.currentPage = String(safePage);
    };

    const initShelves = (root) => {
      root.querySelectorAll('[data-to-home-shelf]').forEach((shelf) => {
        updateShelf(shelf, Number(shelf.dataset.currentPage || 0));
      });
    };

    const initDrawer = () => {
      document.querySelectorAll('[data-to-mobile-toggle]').forEach((toggle) => {
        if (toggle.dataset.bound === 'true') return;
        toggle.dataset.bound = 'true';
        toggle.addEventListener('click', () => {
          const drawer = document.querySelector('[data-to-mobile-drawer]');
          if (!drawer) return;
          drawer.hidden = !drawer.hidden;
          document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
            button.setAttribute('aria-expanded', drawer.hidden ? 'false' : 'true');
          });
        });
      });
    };

    const init = (root = document) => {
      initCards(root);
      initShelves(root);
      initDrawer();
    };

    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('[data-to-mobile-drawer]');
      if (drawer && !drawer.hidden) {
        const clickedToggle = event.target.closest('[data-to-mobile-toggle]');
        const clickedDrawer = event.target.closest('[data-to-mobile-drawer]');
        if (!clickedToggle && !clickedDrawer) {
          drawer.hidden = true;
          document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
            button.setAttribute('aria-expanded', 'false');
          });
        }
      }

      const variantButton = event.target.closest('[data-to-variant]');
      if (variantButton) {
        const card = variantButton.closest('[data-to-product-card]');
        if (!card) return;
        card.querySelectorAll('[data-to-variant]').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        variantButton.classList.add('is-selected');
        variantButton.setAttribute('aria-pressed', 'true');

        const price = card.querySelector('[data-to-product-price]');
        const image = card.querySelector('[data-to-product-image]');
        if (price && variantButton.dataset.price) price.textContent = variantButton.dataset.price;
        if (image && variantButton.dataset.image) image.src = variantButton.dataset.image;
        return;
      }

      const pageButton = event.target.closest('[data-to-home-page-button]');
      if (pageButton) {
        const shelf = pageButton.closest('[data-to-home-shelf]');
        if (!shelf) return;
        const current = Number(shelf.dataset.currentPage || 0);
        const nextPage = pageButton.dataset.toHomePageButton === 'next' ? current + 1 : current - 1;
        updateShelf(shelf, nextPage);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const drawer = document.querySelector('[data-to-mobile-drawer]');
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.querySelectorAll('[data-to-mobile-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('DOMContentLoaded', () => init(document));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
